import React from 'react';
import { Header } from './components/Header';
import { HeroTestimonial } from './components/HeroTestimonial';
import { ProblemSection } from './components/ProblemSection';
import { StorySection } from './components/StorySection';
import { ScienceSection } from './components/ScienceSection';
import { SolutionSection } from './components/SolutionSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-white font-sans" data-id="element-0">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-1">
        <Header data-id="element-2" />
        <main data-id="element-3">
          <HeroTestimonial data-id="element-4" />
          <ProblemSection data-id="element-5" />
          <StorySection data-id="element-6" />
          <ScienceSection data-id="element-7" />
          <SolutionSection data-id="element-8" />
          <TestimonialsSection data-id="element-9" />
          <GuaranteeSection data-id="element-10" />
          <UrgencySection data-id="element-11" />
        </main>
        <Footer data-id="element-12" />
      </div>
    </div>;
}